export const APP_NAME = "SSL Cloud";
